module.exports = __webpack_public_path__ + "img/login_bg.9b6f6370.png";